module.exports = __webpack_public_path__ + "02_mole.57ea5af5.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/papa/layer2/02_mole.png
// module id = PXVH
// module chunks = 0